import { render, staticRenderFns } from "./GenericRichText.vue?vue&type=template&id=2ddc8296&"
import script from "./GenericRichText.vue?vue&type=script&lang=js&"
export * from "./GenericRichText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports